"use strict";

document.addEventListener("DOMContentLoaded", function() {
    (function() {
        /* global Swiper */
        var isMobile = false;
        var visualAnimationTimer = null;
        var visualAnimationReq = null;
        var resizeTimer = null;
        var visualSlide = new Swiper(".swiper--visual", {
            slidesPerView: "auto",
            spaceBetween: 13,
            centeredSlides: true,
            roundLengths: true,
            setWrapperSize: true,
            loop: true,
            speed: 1000,
            observer: true,
            observeParents: true,
            // init: false,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });

        const swiperOptions = {
            slidesPerView: "auto",
            spaceBetween: 22,
            centeredSlides: true,
            loopAdditionalSlides: 5,
            setWrapperSize: true,
            loop: true,
            slideToClickedSlide: true,
            roundLengths: true,
            observer: true,
            observeParents: true,
            cssMode: false,
            // init: false,
            initialSlide: 1,
        }

        const workSlide = new Swiper(".work .swiper-container", {
            ...swiperOptions,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".work .swiper-pagination--all",
                type: "bullets",
                clickable: true,
            },
            on: {
                init: function() {
                    var $thisSlide = this;

                    $thisSlide.slideTo(15, 0);

                    var workSelector = document.querySelector(".section--work");
                    var workSlideSelector = document.querySelectorAll(".work-container .work-slide");
                    var activeIndex = $thisSlide.realIndex;
                    var previousIndex = Math.abs($thisSlide.previousIndex - $thisSlide.loopedSlides);

                    workSlideSelector.forEach(function(item, i) {

                        const paginationElement = Object.assign(document.createElement("span"), {className: `swiper-pagination-bullet${i === $thisSlide.realIndex ? " swiper-pagination-bullet-active" : ""}`, tabIndex: "0", role: "button", "aria-label": `Go to slide ${i + 1}`});
                        paginationElement.addEventListener("click", function() {
                            $thisSlide.slideTo(i, 300);
                        });
                        document.querySelector(".work .swiper-pagination--mo").appendChild(paginationElement);

                        if (activeIndex === i) {
                            workSelector.classList.remove("is-active-0" + (previousIndex + 1));
                            workSelector.classList.add("is-active-0" + (i + 1));
                            workSlideSelector[i].classList.add("is-active");
                        } else {
                            workSlideSelector[i].classList.remove("is-active");
                        }
                    });
                },
                slideChange: function() {
                    var $thisSlide = this;
                    var workSelector = document.querySelector(".section--work");
                    var workSlideSelector = document.querySelectorAll(".work-container .work-slide");
                    var activeIndex = $thisSlide.realIndex;
                    var previousIndex = Math.abs($thisSlide.previousIndex - $thisSlide.loopedSlides);

                    document.querySelectorAll(".work .swiper-pagination--mo .swiper-pagination-bullet").forEach(function(item, i) {
                        if (activeIndex === i) {
                            item.classList.add("swiper-pagination-bullet-active");
                        } else {
                            item.classList.remove("swiper-pagination-bullet-active");
                        }
                    });

                    workSlideSelector.forEach(function(item, i) {
                        if (activeIndex === i) {
                            workSelector.classList.remove("is-active-0" + (previousIndex + 1));
                            workSelector.classList.add("is-active-0" + (i + 1));
                            workSlideSelector[i].classList.add("is-active");
                        } else {
                            workSlideSelector[i].classList.remove("is-active");
                        }
                    });
                },
            },
        });

        // const paginationSwiper = new Swiper(".work .swiper-container", {
        //     ...swiperOptions,
        //     pagination: {
        //         el: ".work .swiper-pagination--mo",
        //         type: "bullets",
        //         clickable: true,
        //         on: {
        //             slideChange: function() {
        //                 console.log(this.realIndex);
        //             },
        //         },
        //     },
        // });

        // workSlide.controller.control = paginationSwiper;

        window.addEventListener("resize", function() {
            if (!resizeTimer) {
                resizeTimer = window.setTimeout(function() {
                    resizeTimer = null;
                    setIsMobile();
                    if (isMobile) {
                        if (visualSlide) {
                            var slides = visualSlide.el.querySelectorAll(".swiper-slide");
                            for (var i = 0; i < slides.length; i++) {
                                var imgWidth = slides[i].querySelector("img").offsetWidth;
                                slides[i].style.width = imgWidth + "px";
                            }
                            visualSlide.update(true);
                        }
                    }

                    if (workSlide) {
                        var slides = workSlide.el.querySelectorAll(".swiper-slide");
                        for (var i = 0; i < slides.length; i++) {
                            var imgWidth =
                                slides[i].querySelector(".work-swiper-img").offsetWidth;
                            if (slides[i].classList.contains(".work-swiper-slide")) {
                                slides[i].style.width = imgWidth + "px";
                            }
                        }
                        workSlide.update(true);
                        //workSlide.slideTo(15, 0);
                    }
                }, 200);
            }
        });

        if (!resizeTimer) {
            resizeTimer = window.setTimeout(function() {
                resizeTimer = null;
                setIsMobile();
                if (isMobile && visualSlide) {
                    visualSlide.update(true);
                }
                if (workSlide) {
                    workSlide.update();
                    //workSlide.slideTo(15, 0);
                }
            }, 200);
        }

        var videos = document.querySelectorAll(".video__controller");
        var videoState = [];
        var ioVideo = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.intersectionRatio > 0) {
                    videoState.map(function(item, i) {
                        if (entry.target === videoState[i].root) {
                            videoState[i].controller.play();
                        }
                    });
                    // entry.target.querySelector('video').play();
                } else {
                    videoState.map(function(item, i) {
                        if (entry.target === videoState[i].root) {
                            videoState[i].controller.pause();
                        }
                    });
                    // entry.target.classList.remove('is-loaded');
                    // entry.target.querySelector('video').pause();
                }
            });
        });

        if (videos.length) {
            videos.forEach(function(video, i) {
                videoState[i] = {
                    root: video,
                    controller: new VideoController(video),
                };
                ioVideo.observe(video);
            });
        }

        var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.intersectionRatio > 0) {
                    var animateEndCallback = function animateEndCallback() {
                        if (!isMobile) {
                            visualAnimationLoopStart(entry.target);
                        } else {
                            visualAnimationLoopEnd(entry.target);
                        }
                    };

                    entry.target.classList.add("is-viewport");
                    randomVisualGroup();

                    visualAnimationEnd(animateEndCallback);
                } else {
                    visualAnimationLoopEnd(entry.target);

                    entry.target.classList.remove("is-viewport");
                }
            });
        });
        var sectionVisualSelector = document.querySelector(".section--visual");
        io.observe(sectionVisualSelector);

        function setIsMobile() {
            if (window.innerWidth > 768) {
                isMobile = false;
            } else {
                isMobile = true;
            }
        }

        function randomVisualGroup() {
            var imageSelector = document.querySelectorAll(".cell__pc");
            var current =
                imageSelector[Math.floor(Math.random() * imageSelector.length)];
            imageSelector.forEach(function(element) {
                element.classList.remove("is-active");
            });
            current.classList.add("is-active");
        }
        // function visualRandomImages() {
        //   var getRandom = function (total) {
        //     return Math.floor(Math.random() * total);
        //   };
        //   var imageArray = [
        //     'visual-01.jpg',
        //     'visual-02.jpg',
        //     'visual-03.jpg',
        //     'visual-04.jpg',
        //     'visual-05.jpg',
        //     'visual-06.jpg'
        //   ];
        //   var imageSelector = document.querySelectorAll('.cell__pc-image');
        //   imageArray.sort(function (a, b) {
        //     return 0.5 - Math.random();
        //   });
        //   imageSelector.forEach(function (e, i) {
        //     e.src = '/int/en/resource/img/meets-arts-new/' + imageArray[i];
        //   });
        // }
        function visualAnimationLoopStart(target) {
            if (visualAnimationReq) {
                clearInterval(visualAnimationReq);
                visualAnimationReq = null;
            }

            visualAnimationReq = window.setInterval(function() {
                if (!isMobile) {
                    if (target.classList.contains("is-viewport")) {
                        target.classList.remove("is-viewport");
                    }
                    if (visualAnimationTimer) {
                        clearTimeout(visualAnimationTimer);
                        visualAnimationTimer = null;
                    }
                    visualAnimationTimer = window.setTimeout(function() {
                        target.classList.add("is-viewport");
                        randomVisualGroup();
                    }, 200);
                } else {
                    if (visualAnimationReq) {
                        clearInterval(visualAnimationReq);
                        visualAnimationReq = null;
                    }
                    if (visualAnimationTimer) {
                        clearTimeout(visualAnimationTimer);
                        visualAnimationTimer = null;
                    }
                }
            }, 4000);
        }

        function visualAnimationLoopEnd(target) {
            if (visualAnimationReq) {
                window.clearInterval(visualAnimationReq);
                visualAnimationReq = null;
            }
            if (visualAnimationTimer) {
                clearTimeout(visualAnimationTimer);
                visualAnimationTimer = null;
            }
            if (!target.classList.contains("is-viewport")) {
                target.classList.add("is-viewport");
                randomVisualGroup();
            }
        }

        function visualAnimationEnd(callback) {
            var objectSelector = document.querySelector(".cell__pc-item:nth-child(5)");
            if (objectSelector) {
                objectSelector.addEventListener("animationend", function() {
                    if (callback && typeof callback === "function") {
                        callback();
                    }
                });
            }
        }

        // document.addEventListener("readystatechange", (event) => {
        //     console.log(event.target.readyState);
        //     if (event.target.readyState === "complete") {
        //         workSlide.init();
        //         visualSlide.init();
        //     }
        // });

    })();
});